import React from "react";
import { useDispatch } from "react-redux";
import { ReactComponent as LogoutSvg } from "../../assets/images/logoutsvg.svg";
import { Button } from "./Button";
import { clearUserInfo } from "../../store/auth/authSlice";
import { useNavigate } from "react-router-dom";
import { setClearClaimDetails } from "../../store/claim/claimSlice";

export const Logout = ({ close }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(setClearClaimDetails())
    dispatch(clearUserInfo());
    navigate('/');
  };

  return (
    <div className="text-center flex items-center flex-col pt-4 px-2">
      <LogoutSvg />
      <h3 className="text-secondarytwo text-center text-f20 font-semibold my-2">
        Comeback Soon!
      </h3>
      <p className="text-secondary pb-4 w-64 px-6 text-f16">
        Are you sure you want to logout from TREVEX?
      </p>
      <hr className="w-full" />
      <div className="flex text-secondary pt-4 w-full gap-4">
        <Button
          onClick={close}
          classes="bg-primary px-4 py-2 text-white text-f14 rounded w-full"
        >
          Cancel
        </Button>
        <Button
          onClick={handleLogout}
          classes="bg-primary px-4 py-2 text-white text-f14 rounded w-full"
        >
          Logout
        </Button>
      </div>
    </div>
  );
};
